module.exports = __webpack_public_path__ + "static/media/student-setting-teacher01.c6d786e0.png";